// Score Logo - Lightning S with orbital circle and two colored atoms
// Two atoms in brand colors representing two people connecting

export const ScoreLogo = ({ size = 40, variant = 'dark' }) => {
  const id = `score-logo-${Math.random().toString(36).substr(2, 9)}`;
  
  // Orbit color based on variant
  const orbitColor = variant === 'light' ? '#ffffff' : '#374151';
  const glowOpacity = variant === 'light' ? '0.5' : '0.3';
  
  // Atom colors - branded colors that pop
  // Atom 1: Coral/Red (warm, energetic)
  // Atom 2: Orange/Gold (complementary, inviting)
  
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none"
    >
      <defs>
        {/* Fire gradient for lightning bolt */}
        <linearGradient id={`${id}-fire`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#fbbf24" />
          <stop offset="35%" stopColor="#f97316" />
          <stop offset="65%" stopColor="#ef4444" />
          <stop offset="100%" stopColor="#dc2626" />
        </linearGradient>
        
        {/* Glow effect for bolt */}
        <filter id={`${id}-glow`} x="-100%" y="-100%" width="300%" height="300%">
          <feGaussianBlur stdDeviation="2.5" result="blur"/>
          <feFlood floodColor="#ef4444" floodOpacity={glowOpacity}/>
          <feComposite in2="blur" operator="in"/>
          <feMerge>
            <feMergeNode/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        
        {/* Shadow for atoms */}
        <filter id={`${id}-atom-shadow`} x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="1" stdDeviation="1.5" floodColor="#000" floodOpacity="0.25"/>
        </filter>
        
        {/* Gradient for orbit ring */}
        <linearGradient id={`${id}-orbit`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={orbitColor} stopOpacity="1" />
          <stop offset="50%" stopColor={orbitColor} stopOpacity="0.6" />
          <stop offset="100%" stopColor={orbitColor} stopOpacity="1" />
        </linearGradient>
        
        {/* Atom 1 gradient - Coral/Red */}
        <radialGradient id={`${id}-atom1`} cx="35%" cy="35%" r="60%">
          <stop offset="0%" stopColor="#f87171" />
          <stop offset="100%" stopColor="#dc2626" />
        </radialGradient>
        
        {/* Atom 2 gradient - Orange/Gold */}
        <radialGradient id={`${id}-atom2`} cx="35%" cy="35%" r="60%">
          <stop offset="0%" stopColor="#fcd34d" />
          <stop offset="100%" stopColor="#f59e0b" />
        </radialGradient>
      </defs>
      
      {/* Outer orbit circle */}
      <circle 
        cx="50" cy="50" r="44" 
        stroke={`url(#${id}-orbit)`}
        strokeWidth="3.5"
        fill="none"
      />
      
      {/* Lightning bolt S in center */}
      <g filter={`url(#${id}-glow)`}>
        {/* Main bolt */}
        <path 
          d="M58 14 L40 50 L60 50 L42 86" 
          stroke={`url(#${id}-fire)`}
          strokeWidth="10" 
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        {/* Inner highlight for 3D depth */}
        <path 
          d="M55 20 L43 48 L57 48 L46 78" 
          stroke="rgba(255,255,255,0.5)"
          strokeWidth="3" 
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      
      {/* Atom 1 - Top right - Coral/Red */}
      <g filter={`url(#${id}-atom-shadow)`}>
        <circle 
          cx="84" cy="24" r="8" 
          fill={`url(#${id}-atom1)`}
        />
        {/* Highlight */}
        <circle 
          cx="81" cy="21" r="2.5" 
          fill="rgba(255,255,255,0.7)"
        />
      </g>
      
      {/* Atom 2 - Bottom left - Orange/Gold */}
      <g filter={`url(#${id}-atom-shadow)`}>
        <circle 
          cx="16" cy="76" r="8" 
          fill={`url(#${id}-atom2)`}
        />
        {/* Highlight */}
        <circle 
          cx="13" cy="73" r="2.5" 
          fill="rgba(255,255,255,0.7)"
        />
      </g>
    </svg>
  );
};

export default ScoreLogo;
